import React from 'react'
import { NavLink } from 'react-router-dom'
import { DASHBOARD_ROUTES } from '../../helpers/constants'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

const AsideNav: React.FunctionComponent<any> = () => {
    return (
        <nav className='w-[230px] shadow-sm flex-shrink-0 border-full rounded-xl hidden lg:flex flex-col mr-4 md:mr-6 h-auto mb-auto bg-white overflow-hidden pb-24'>
            {/* SIDE CONTENT */}
            {/* LOOP OVER NAVIGATION HERE */}
            <ul>
                {DASHBOARD_ROUTES.map((route, i) => {
                    return (
                        <li key={i}>
                            <NavLink
                                to={route.to}
                                end={route.to === ''}
                                className={({ isActive }) =>
                                    isActive
                                        ? 'text-black relative activeNavLink'
                                        : 'relative text-[--tb-text] hover:text-black'
                                }
                            >
                                <div className='flex flex-row items-center pl-4 relative'>
                                    {route.icon && (
                                        <span className='mr-3 w-5 flex items-center justify-center'>
                                            <DynamicFaIcon iconName={route.icon.iconName} />
                                        </span>
                                    )}
                                    <span
                                        className={`${
                                            i === DASHBOARD_ROUTES.length - 1 ? 'border-none' : 'border-b'
                                        } flex w-full py-3 borderFadedPrimaryColor font-medium justify-between gap-x-2 items-center`}
                                    >
                                        {route.displayName}
                                    </span>
                                </div>
                            </NavLink>
                            {route.children && (
                                <ul className='pb-1'>
                                    {route.children.map((child) => (
                                        <li key={child.to}>
                                            <NavLink
                                                to={child.to}
                                                className={({ isActive }) =>
                                                    isActive
                                                        ? 'text-black relative activeNavLink'
                                                        : 'relative text-[--tb-text] hover:text-black'
                                                }
                                            >
                                                <div className='flex flex-row items-center pl-12 pr-4 py-2 text-sm'>
                                                    {child.icon && (
                                                        <span className='mr-2 w-4 flex items-center justify-center'>
                                                            <DynamicFaIcon iconName={child.icon.iconName} />
                                                        </span>
                                                    )}
                                                    <span className='font-medium'>{child.displayName}</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}

export default AsideNav
